const cellSize = 35;

export {
	cellSize,
}
